module.exports = __webpack_public_path__ + "static/11-52c7ffed1e12547dfd17e6860b9dd51b.png";